import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Download } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/meta-pixel';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 bg-beige-100 text-center" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 sm:p-12 rounded-3xl shadow-xl border border-gold-200 relative overflow-hidden" data-id="element-95">
          <div className="absolute top-0 inset-x-0 h-2 bg-gold-500" data-id="element-96"></div>

          <img src="https://cdn.magicpatterns.com/uploads/wQKCzNYnmPMBMyv1YnEH34/Copia_de_DESCARGALO_AHORA_(1).png" alt="3 Clases + Bonus - Kit Rompe Patrones" className="w-full max-w-md mx-auto rounded-2xl mb-8 object-contain" data-id="element-97" />

          <p className="text-gray-500 text-lg mb-2 line-through decoration-red-400 decoration-2" data-id="element-98">
            VALOR TOTAL: €250
          </p>
          <h2 className="text-2xl font-bold text-dark mb-6" data-id="element-99">
            PRECIO ESPECIAL POR HOY
          </h2>

          <div className="flex justify-center items-center space-x-4 mb-2" data-id="element-100">
            <span className="text-6xl sm:text-7xl font-bold text-dark" data-id="element-101">
              €27
            </span>
            <div className="flex flex-col items-start" data-id="element-102">
              <span className="text-sm text-gray-500 font-medium" data-id="element-103">
                PAGO ÚNICO
              </span>
              <span className="bg-red-100 text-red-600 text-sm font-bold px-2 py-1 rounded" data-id="element-104">
                85% OFF
              </span>
            </div>
          </div>
          <p className="text-gray-500 text-base mb-8" data-id="element-105">
            🇦🇷 Aprox. $43.800 Pesos Arg
          </p>

          <div className="mb-8" data-id="element-106">
            <p className="text-red-500 font-medium flex items-center justify-center space-x-2" data-id="element-107">
              <span data-id="element-108">⏰ Esta oferta expira en:</span>
            </p>
            <CountdownTimer data-id="element-109" />
          </div>

          <button onClick={() => {
          trackAddToCart();
          window.location.href = 'https://9bsyg4-ct.myshopify.com/cart/57447625556316:1';
        }} className="w-full sm:w-auto bg-gold-500 hover:bg-gold-600 text-white font-bold text-xl py-5 px-12 rounded-full shadow-[0_10px_20px_rgba(212,168,83,0.3)] transform transition hover:-translate-y-1 mb-8 flex items-center justify-center mx-auto space-x-2" data-id="element-110">
            <span data-id="element-111">🛒 AGREGAR AL CARRITO</span>
          </button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-112">
            <div className="flex items-center space-x-1" data-id="element-113">
              <Download className="w-4 h-4 text-green-500" data-id="element-114" />
              <span data-id="element-115">Descarga inmediata</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-116">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-117" />
              <span data-id="element-118">Pago seguro</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-119">
              <CreditCard className="w-4 h-4 text-green-500" data-id="element-120" />
              <span data-id="element-121">Paypal o Tarjetas</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}